const resolveOptional = (key, fallback) => import.meta.env[key] || fallback

export const config = {
  githubUrl: resolveOptional('VITE_GITHUB_URL', 'https://github.com/OWASP/VulnReach'),
  pypiUrl: resolveOptional('VITE_PYPI_URL', 'https://pypi.org/project/vulnreach/'),

  // Site metadata
  siteUrl: resolveOptional('VITE_SITE_URL', 'https://vulnreach.com'),
  siteName: 'VulnReach',

  // Feature flags
  enableAnalytics: import.meta.env.VITE_ENABLE_ANALYTICS === 'true',
}
